import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { baseIcon } from '../data/icon';
import { assert } from '../../lib/utils';
import setting from '../setting';

const css = require('./base-icon.css').default;

export default function ({ icon, onSelect }: {
    icon: baseIcon,
    onSelect: (e: React.MouseEvent, command: string) => void,
}) {
    const img = useRef<HTMLImageElement>(null);
    const [showMenu, setShowMenu] = useState(false);
    const [iconRect, setIconRect] = useState({
        left: icon.left,
        top: icon.top,
        width: 0,
        height: 0,
    });

    const commands = icon.command instanceof Array ? icon.command : [];

    useEffect(() => {
        assert(img.current !== null, '');
        setIconRect({
            left: icon.left,
            top: icon.top,
            width: img.current.width,
            height: img.current.height,
        });
    });

    return (
    <>
        <img
            ref={img}
            src={`${setting.補充資料按鈕路徑}${icon.icon || ''}`}
            style={{
                position: 'absolute',
                left: `${icon.left}px`,
                top: `${icon.top}px`,
            }}
            onClick={e => {
                if (typeof icon.command === 'string') {
                    onSelect(e, icon.command);
                } else {
                    const pageDoc = document.body.querySelector('iframe')?.contentDocument;
                    setShowMenu(true);
                    function closeMenu() {
                        setShowMenu(false);
                        document.body.removeEventListener('click', closeMenu);
                        if (pageDoc) {
                            pageDoc.body.removeEventListener('click', closeMenu);
                        }
                    }
                    document.body.addEventListener('click', closeMenu);
                    if (pageDoc) {
                        pageDoc.body.addEventListener('click', closeMenu);
                    }
                    e.stopPropagation();
                }
            }}
            onMouseOver={e => {
                assert(e.target instanceof HTMLImageElement, '');
                if (icon.hover.length > 0) {
                    e.target.style.cssText = e.target.style.cssText + icon.hover;
                }
            }}
            onMouseOut={e => {
                assert(e.target instanceof HTMLImageElement, '');
                if (icon.hover.length > 0) {
                    e.target.style.cssText = e.target.style.cssText.slice(0, icon.hover.length * -1);
                }
            }}
            draggable={false}
        />
        <Menu show={showMenu} target={iconRect}>
            {commands.map(i => <div onClick={e => onSelect(e, i.command)}>{i.name}</div>)}
        </Menu>
    </>);
}

function Menu({ show, target, children }: {
    show: boolean,
    target: {
        left: number,
        top: number,
        width: number,
        height: number,
    }
    children: JSX.Element[],
}) {
    const menu = useRef<HTMLDivElement>(null);
    const [left, setLeft] = useState(target.left);
    
    const top = target.top + target.height;

    useEffect(() => {
        assert(menu.current !== null, '');
        setLeft(target.left + (target.width / 2) - (menu.current.offsetWidth / 2));
    });

    return (
    <div ref={menu}
        id={css.menu}
        className={show ? '' : css.close}
        style={{
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            fontSize: '3em',
        }}
    >
        {children}
    </div>);
}
